export default "__VITE_ASSET__COygCWag__"